import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../assest/images/logo.png';
import { Link ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import constants from "../../services/constants";
import Style from '../Styles/DashboardStyle.module.css';
import Button from '../Styles/Button.module.css';
import { MdNotifications, MdHelpOutline, MdOutlineHome  } from "react-icons/md";
import { useDispatch } from 'react-redux';
import { userlogout } from '../../store/authSlice';

const DashboardHeader = ()=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showNotification, setShowNotification] = useState(false);
    const { isAuthenticated, user } = useSelector((state) => state.auth);
    const notificationHandler=()=>{
        setShowNotification(!showNotification)
    }
    const handleLogout = () => {
        // Remove token from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('userDetail');
        dispatch(userlogout());
        // Redirect to home or login page
        navigate('/');
    };
    const menuToggle = () => {
        document.body.classList.add("active");
      };
    return(
        <div className={Style.DBheader}>
            <Container>
                <Row>
                    <Col>
                        <div className={Style.logo}>
                            <img src={Logo} />
                        </div>
                        <ul className={Style.userLogout}>
                            <li>
                                <button type="button" onClick={notificationHandler}><MdNotifications /></button>
                                {showNotification &&
                                    <div className={Style.notificatopnBox}>
                                        <h5>Notifications</h5>
                                        <ul className={Style.boxList}>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                            <li>
                                                <h6>Event Alert</h6>
                                                <p>You are cordially invited to a fashion exhibition showcasing the VAR-SHI label by Vidushi Gulati, Batch of 2010, at Taj Bengal on October 18th. Join us at Stall 31F between 11 AM and 9 PM. We look forward to your visit!</p>
                                            </li>
                                        </ul>
                                    </div>
                                }
                            </li>
                            <li>
                                <Link to="/contact"><MdHelpOutline /></Link>
                            </li>
                            <li>
                                <Link to='/'><MdOutlineHome  /></Link>
                            </li>
                            <li className={Style.UserDetail}>
                                <button type="button" onClick={menuToggle}>
                                   {user && <img  alt=""  src={constants.IMAGE_BASE_URL+'user/'+user.image} /> }
                                    {user &&<h6>{user.name}</h6>}
                                    {user &&<span className={Style.UserId}>{user.id_number}</span>}
                                </button>
                            </li>
                            {/* <li>{isAuthenticated && user.name}</li> */}
                            <li className={Style.logoutBtn}>{isAuthenticated && <Link to="/" onClick={handleLogout}>Logout</Link>}</li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DashboardHeader;